var Category;
(function (Category) {
    Category["Today"] = "today";
    Category["Past"] = "past";
    Category["Upcoming"] = "upcoming";
})(Category || (Category = {}));
export async function getEventsFromUrl(url) {
    return await fetch(url)
        .then((r) => r.json())
        .catch((e) => {
        console.error(e);
        return [];
    });
}
function isDateInFuturePastOrPresent(firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) < secondDate.setHours(0, 0, 0, 0)) {
        return Category.Upcoming;
    }
    else if (firstDate.setHours(0, 0, 0, 0) === secondDate.setHours(0, 0, 0, 0)) {
        return Category.Today;
    }
    else {
        return Category.Past;
    }
}
export function categoriseEventsByDate(events) {
    const today = new Date();
    const eventsByDate = {
        today: [],
        past: [],
        upcoming: [],
        total: events.length,
    };
    events.forEach((event) => {
        const category = isDateInFuturePastOrPresent(today, event.date);
        eventsByDate[category].push(event);
    });
    return eventsByDate;
}
